import {resolveBackground} from '#core/utils/color-utils.js';

import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

export function dialogsConfig(PALETTE) {
    return {
        Dialog: {
            base: {
                borderColor: 'transparent',
                borderStyle: 'none',
                borderWidth: 0,
                background: 'transparent',
                outline: 'none',
                fontFamily: BasePalette.palette.FONT_FAMILY,
                ...PALETTE.DIALOGS_DEFAULT_TEXT,
            },
            dialogContent: {
                style: {
                    ...resolveBackground(PALETTE.DIALOGS_CONTAINER_BG),
                    borderRadius: PALETTE.DIALOGS_CONTAINER_BORDER_RADIUS,
                },
            },
            header: {
                title: {
                    style: {
                        ...PALETTE.DIALOGS_TITLE_TEXT,
                    },
                },
            },
            closeButtonContainer: {
                style: {
                    right: 0,
                    top: 'initial',
                    bottom: 'calc(100% + 8px)',
                    left: 'initial',
                },
            },
            closeButton: generateCloseButton(PALETTE.DIALOGS_CLOSE_BUTTON),
            _mobile_closeButton: generateCloseButton(PALETTE.DIALOGS_CLOSE_BUTTON_MOBILE, CLOSE_BUTTON_TYPES.CIRCULAR),
            overlay: {
                ...resolveBackground(PALETTE.DIALOGS_OVERLAY_BG),
            },
            disabledOverlay: {
                base: {
                    style: {
                        ...resolveBackground(PALETTE.DIALOGS_DISABLED_OVERLAY_BG),
                    },
                },
            },
        },
        Overlay: {
            style: {
                container: {
                    fontFamily: BasePalette.palette.FONT_FAMILY,
                    ...PALETTE.DIALOGS_DEFAULT_TEXT,
                },
                overlay: {
                    ...resolveBackground(PALETTE.DIALOGS_OVERLAY_BG),
                },
            },
        },
    };
}
